<script setup lang="ts">
// Компонент используется пока у нас не SPA, для более бесшовных переходов, если это возможно
import type { RouterLinkProps } from 'vue-router';
import { useRouter } from 'vue-router';
import { computed } from 'vue';
import { NOT_FOUND } from '@/modules/main-screen/constants';
import { SETTINGS_NOT_FOUND } from '@/entities/staged/settings';

const { to } = defineProps<{
  to: RouterLinkProps['to'];
  custom?: RouterLinkProps['custom'];
}>();

const router = useRouter();

const isResolved = computed(() => {
  if (!router) {
    return false;
  }
  const route = router.resolve(to);
  if (route.name === SETTINGS_NOT_FOUND || route.name === NOT_FOUND) {
    return false;
  }

  return !!route.matched.length;
});

const computedComponent = computed(() => {
  return isResolved.value ? 'router-link' : 'a';
});
const params = computed(() => {
  if (isResolved.value) {
    return {
      to
    };
  }
  return {
    href: to
  };
});
</script>

<template>
  <component
    :is="computedComponent"
    v-bind="params"
  >
    <slot />
  </component>
</template>

<i18n lang="json">{}</i18n>
